export async function refreshAccessToken() {
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) {
    return null;
  }

  try {
    const response = await fetch("/api/gym/token/refresh/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    const data = await response.json();

    if (!response.ok || !data.access) {
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      return null;
    }

    localStorage.setItem("accessToken", data.access);
    return data.access;
  } catch {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    return null;
  }
}

export async function authFetch(url, options = {}) {
  const makeRequest = async (token) => {
    const baseHeaders = options.headers || {};
    const headers = token
      ? {
          ...baseHeaders,
          Authorization: `Bearer ${token}`,
        }
      : {
          ...baseHeaders,
        };

    return fetch(url, {
      ...options,
      headers,
    });
  };

  let accessToken = localStorage.getItem("accessToken");
  let response = await makeRequest(accessToken);

  if (response.status !== 401) {
    return response;
  }

  const newAccessToken = await refreshAccessToken();

  if (!newAccessToken) {
    return response;
  }

  response = await makeRequest(newAccessToken);
  return response;
}